import { getSession, signIn } from "next-auth/react";
import { useEffect } from "react";

export default function SessionRefresher() {
    useEffect(() => {
        const interval = setInterval(
            () => {
                if (document.visibilityState === "visible") {
                    getSession().then((data) => {
                        if (data?.error === "RefreshAccessTokenError") {
                            console.warn("Token refresh failed. Redirecting to login...");
                            return signIn("keycloak");
                        }
                    });
                }
            },
            5 * 60 * 1000
        );

        return () => clearInterval(interval);
    }, []);

    return null;
}
